<template>
    <div class="body" id="body">
        <div class="header">
            <div class="header-left">
                <div class="header-left-logo">
                    <img src="/assets/images/logoMain.jpg">
                </div>
                <div class="header-left-filter">
                    <img src="/assets/images/filter.svg"/>
                </div>
            </div>
            <div class="header-right">
                <transition name="fade">
                    <div class="header-villages" v-bind:key="52353563">
                        <div v-for="(vill, i) in villages"
                             :class="($route.params.village == vill.ID || currentVillage.ID == vill.ID)? 'header-villages-village active-village': 'header-villages-village'"
                             :data-to="vill.ID" v-bind:key="i" :data-coords="vill.PROPERTY_510"
                             v-show="(vill.PROPERTY_521 == '340' || showAllVill) && (vill.PROPERTY_526 == site || site == '0') || $route.path.includes('square')">
                            <div class="header-villages-village-logo">
                                <img :src="vill.PROPERTY_516"/>
                            </div>
                            <div class="header-villages-village-name" :data-to="vill.ID" v-bind:key="i"
                                 :data-coords="vill.PROPERTY_510" @click="goTo"
                                 @mouseover="currentVillage = villages.find(villag => villag.ID === vill.ID);"
                                 @mouseleave="currentVillage = villages.find(villag => villag.ID === $route.params.village);"
                            >
                                {{vill.NAME}}
                            </div>
                        </div>
                        <div class="header-rigth-all" @click="showAllVill = !showAllVill" v-if="showAllVill">
                            Свернуть
                            <div style="transform: rotate(-90deg); color:#9EADBA; margin-left: .5vh">></div>
                        </div>
                    </div>
                </transition>
                <div class="header-rigth-all" @click="showAllVill = !showAllVill" v-if="!showAllVill">
                    Все&#160;поселки&#160;>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="filter" v-if="filter.show" key="87683">
                <div class="filter-values">
                    <div class="filter-values-value">
                        <toggle-button
                                color="#FF5C00"
                                :width="winHeight * 2.9 / 100"
                                :height="winHeight * 1.8 / 100"
                                v-model="filter.gas"/>
                        <div class="filter-values-value-name">Подключен газ</div>
                    </div>
                    <div class="filter-values-value">
                        <toggle-button
                                color="#FF5C00"
                                :width="winHeight * 2.9 / 100"
                                :height="winHeight * 1.8 / 100"
                                v-model="filter.water"/>
                        <div class="filter-values-value-name">Вода</div>
                    </div>
                    <div class="filter-values-value">
                        <toggle-button
                                color="#FF5C00"
                                :width="winHeight * 2.9 / 100"
                                :height="winHeight * 1.8 / 100"
                                v-model="filter.roads"/>
                        <div class="filter-values-value-name">Дороги</div>
                    </div>
                    <div class="filter-values-value">
                        <toggle-button
                                color="#FF5C00"
                                :width="winHeight * 2.9 / 100"
                                :height="winHeight * 1.8 / 100"
                                v-model="filter.elctr"/>
                        <div class="filter-values-value-name">Электричество</div>
                    </div>
                    <div class="filter-values-value">
                        <toggle-button
                                color="#FF5C00"
                                :width="winHeight * 2.9 / 100"
                                :height="winHeight * 1.8 / 100"
                                v-model="filter.live"/>
                        <div class="filter-values-value-name">Жилой</div>
                    </div>
                </div>
                <div class="filter-values-range">
                    <div class="filter-values-range-value">От</div>
                    <input type="tel" v-model="filter.minPrice" placeholder="0">
                    <div class="filter-values-range-separate"></div>
                    <div class="filter-values-range-value">До</div>
                    <input type="text" v-model="filter.maxPrice" placeholder="10 000 000">
                </div>
                <div class="filter-values-button">
                    Подобрать поселок
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-if="showDetailVill" class="detail" key="846321313">
                <div class="detail-left">
                    <div class="detail-left-logo">
                        <img :src="currentVillage.PROPERTY_516"/>
                    </div>
                    <div class="detail-left-name">
                        {{currentVillage.NAME}}
                    </div>
                </div>
                <div class="detail-right">
                    <div class="detail-right-props">
                        <div class="detail-right-props-prop" v-if="currentVillage.PROPERTY_524">
                            <div class="detail-right-props-prop-image">
                                <img src="/assets/images/price.svg"/>
                            </div>
                            <div class="detail-right-props-prop-name">
                                ≈ {{currentVillage.PROPERTY_524}} тыс.₽
                            </div>
                        </div>
                        <div class="detail-right-props-prop" v-if="currentVillage.PROPERTY_523">
                            <div class="detail-right-props-prop-image">
                                <img :src="(currentVillage.PROPERTY_359)?'/assets/images/fire.svg':'/assets/images/fireoff.svg'"/>
                            </div>
                            <div class="detail-right-props-prop-name">
                                Газ: {{currentVillage.PROPERTY_523}}
                            </div>
                        </div>
                        <div class="detail-right-props-prop">
                            <div class="detail-right-props-prop-image">
                                <img :src="(currentVillage.PROPERTY_360)?'/assets/images/water.svg' : '/assets/images/wateroff.svg'"/>
                            </div>
                            <div class="detail-right-props-prop-name">
                                Вода
                            </div>
                        </div>
                        <div class="detail-right-props-prop">
                            <div class="detail-right-props-prop-image">
                                <img :src="(currentVillage.PROPERTY_358)? '/assets/images/road.svg' :'/assets/images/roadoff.svg'"/>
                            </div>
                            <div class="detail-right-props-prop-name">
                                Дороги
                            </div>
                        </div>
                        <div class="detail-right-props-prop">
                            <div class="detail-right-props-prop-image">
                                <img :src="(currentVillage.PROPERTY_358)? '/assets/images/electrification.svg' : '/assets/images/electrificationoff.svg'"/>
                            </div>
                            <div class="detail-right-props-prop-name">
                                Эл-во
                            </div>
                        </div>
                        <div class="detail-right-props-prop" v-if="currentVillage.PROPERTY_522">
                            <div class="detail-right-props-prop-image">
                                <img src="/assets/images/peaple.svg"/>
                            </div>
                            <div class="detail-right-props-prop-name">
                                {{currentVillage.PROPERTY_522}}
                            </div>
                        </div>
                    </div>
                    <a v-if="currentVillage.PROPERTY_533" class="detail-right-more" :href="currentVillage.PROPERTY_533"
                       target="_blank">
                        Подробнее
                    </a>
                    <div class="filter-values-button" @click="toogleCallback">
                        Оставить заявку
                    </div>
                    <div class="detail-right-close">
                        <img src="/assets/images/close.svg" @click="closeDetailVill">
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="callback" v-if="showCallback" key="684646843213">
                <div class="callback-content">
                    <div class="callback-content-close">
                        <img @click="toogleCallback" src="/assets/images/close.svg">
                    </div>
                    <div class="callback-content-head">
                        Заказать звонок
                    </div>
                    <div class="callback-content-descr">
                        Введите данные и нажмите заказать, чмы свяжеимся с Вами в течении часа.
                    </div>
                    <div class="callback-content-inputs">
                        <div class="callback-content-inputs-input">
                            <FloatingLabel
                                    :config="{label: 'Ваше Имя', height: winHeight * 4.6 /100, hasClearButton: false}">
                                <input name="default" v-model="order.name" type="text">
                            </FloatingLabel>
                        </div>
                        <div class="callback-content-inputs-input">
                            <FloatingLabel
                                    :config="{label: 'Телефон', height: winHeight * 4.6 /100, hasClearButton: false}">
                                <input name="default" v-model="order.phone" v-mask="'+7 (###) ### ## ##'" type="text">
                            </FloatingLabel>
                        </div>
                        <div class="callback-content-inputs-input">
                            <FloatingLabel
                                    :config="{label: 'Эл. Почта', height: winHeight * 4.6 /100, hasClearButton: false}">
                                <input name="default" v-model="order.mail" type="text">
                            </FloatingLabel>
                        </div>
                        <div class="callback-content-inputs-input">
                            <FloatingLabel
                                    :config="{label: 'Введите комментарий', height: winHeight * 12.1 /100, hasClearButton: false}">
                                <input name="wrapper" v-model="order.comment" type="text">
                            </FloatingLabel>
                        </div>
                        <div class="callback-content-button" @click="newOrder">
                            Заказать звонок
                        </div>
                        <div class="callback-content-note">
                            *Нажимая на кнопку "Записаться" вы принимаете условия<br>
                            <a href="#" target="_blank"> Соглашения об использовании сайта</a>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div v-if="loading && $route.params.village" class="loading">
            <texture
                    style="
                    position: absolute
                    ;top: 50vh;
                    left: 50vw;z-index: 999;
                        background: linear-gradient(45deg, transparent 49%, #FF5C00 50%, #FF5C00 50%, transparent 51%, transparent), linear-gradient(-45deg, transparent 49%, #FF5C00 50%, #FF5C00 50%, transparent 51%, transparent);
                        border: 1px #FF5C00 solid;
                        background-size: 16px 16px;
                        background-position: 0% 0%;"></texture>
        </div>
        <!--        <div class="animation">-->
        <!--            <img src="/assets/images/animation.gif"/>-->
        <!--        </div>-->

        <div v-if="showMap" class="map">
            <yandex-map style="width: 100%; height: 70vh"
                        :coords="coordsCenter"
                        :zoom="12"
                        :controls="[]"
                        @map-was-initialized="firstMapInit"
                        ref="ymap"
            >
            </yandex-map>
            <transition name="fade">
                <div v-if="choosedLand != null && lands[choosedLand]" class="popup" key="5135">
                    <div class="popup-close" @click="closeDetail">Закрыть</div>
                    <div class="popup-head">
                        {{lands[choosedLand].PROPERTY_366}} соток
                    </div>
                    <div class="popup-info">
                        <div class="popup-info-litera">
                            Участок № {{lands[choosedLand].PROPERTY_437}}
                        </div>
                        <div class="popup-info-cadastr">
                            K№ <a target="_blank" :href="'https://pkk.rosreestr.ru/#/search/?text='+lands[choosedLand].PROPERTY_377+'&type=1&opened='+parseInt(lands[choosedLand].PROPERTY_377.split(':')[0])+':'+parseInt(lands[choosedLand].PROPERTY_377.split(':')[1])+':'+parseInt(lands[choosedLand].PROPERTY_377.split(':')[2])+':'+parseInt(lands[choosedLand].PROPERTY_377.split(':')[3])">{{lands[choosedLand].PROPERTY_377}}</a>
                        </div>
                    </div>
                    <div class="popup-price">
                        <transition name="slide-down">
                            <div v-if="showDetail" class="popup-price-prices" key="8463">
                                <div class="popup-price-prices-item">
                                    <div class="popup-price-prices-item-name">
                                        Участок
                                    </div>
                                    <div v-if="addDiscuont && lands[choosedLand].PROPERTY_366 && parseInt(lands[choosedLand].PROPERTY_365) > 0"
                                         class="popup-price-prices-item-discount">
                                        - {{parseInt(lands[choosedLand].PROPERTY_366 *
                                        lands[choosedLand].PROPERTY_364*(lands[choosedLand].PROPERTY_365/100)).toLocaleString()}}
                                        ₽
                                    </div>
                                    <div class="popup-price-prices-item-price" v-if="lands[choosedLand].PROPERTY_366 && addDiscuont"
                                         :style="'color:'+((addDiscuont)? '':'#FF5C00')">
                                        {{parseInt(lands[choosedLand].PROPERTY_366 *
                                        lands[choosedLand].PROPERTY_364*(1-lands[choosedLand].PROPERTY_365/100)).toLocaleString()}}
                                        ₽
                                    </div>
                                    <div class="popup-price-prices-item-price" v-if="lands[choosedLand].PROPERTY_366 && !addDiscuont"
                                         :style="'color:'+((addDiscuont)? '':'#FF5C00')">
                                        {{parseInt(lands[choosedLand].PROPERTY_366 *
                                        lands[choosedLand].PROPERTY_364).toLocaleString()}}
                                        ₽
                                    </div>
                                </div>
                                <div class="popup-price-prices-item">
                                    <div class="popup-price-prices-item-name">
                                        Коммуникации
                                    </div>
                                    <div class="popup-price-prices-item-price"
                                         :style="'color:'+((addDiscuont)? '':'#FF5C00')">
                                        {{parseInt(parseInt(lands[choosedLand].PROPERTY_367) +
                                        parseInt(lands[choosedLand].PROPERTY_369) +
                                        parseInt(lands[choosedLand].PROPERTY_371)).toLocaleString()}} ₽
                                    </div>
                                </div>
                                <div class="popup-price-prices-item"
                                     v-if="parseInt(lands[choosedLand].PROPERTY_365) > 0">
                                    <div class="popup-price-prices-item-name">
                                        Скидка
                                    </div>
                                    <div class="control-group control-checkbox popup-price-prices-item-checkbox">
                                        <label class="control control-checkbox">
                                            <input type="checkbox" v-model="addDiscuont">
                                            <div class="control_indicator"></div>
                                        </label>
                                    </div>
                                    <div v-if="addDiscuont"
                                         class="popup-price-head-discount">
                                        - {{parseInt(lands[choosedLand].PROPERTY_365)}} %
                                    </div>
                                    <div v-if="!addDiscuont && parseInt(lands[choosedLand].PROPERTY_365) > 0"
                                         class="popup-price-head-discount-inactive">
                                        - {{parseInt(lands[choosedLand].PROPERTY_365)}} %
                                    </div>
                                    <div v-if="addDiscuont && lands[choosedLand].PROPERTY_366"
                                         class="popup-price-prices-item-price discount-active">
                                        - {{parseInt(lands[choosedLand].PROPERTY_366 *
                                        lands[choosedLand].PROPERTY_364*(lands[choosedLand].PROPERTY_365/100)).toLocaleString()}}
                                        ₽
                                    </div>
                                    <div v-if="!addDiscuont && lands[choosedLand].PROPERTY_366"
                                         class="popup-price-prices-item-price discount-inactive">
                                        - {{parseInt(lands[choosedLand].PROPERTY_366 *
                                        lands[choosedLand].PROPERTY_364*(lands[choosedLand].PROPERTY_365/100)).toLocaleString()}}
                                        ₽
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <div class="popup-price-head" @click="toogleDetail">
                            <div>
                                Итого стоимость: <img v-if="!showDetail" src="/assets/images/arrowDown.svg"> <img
                                    v-if="showDetail" src="/assets/images/arrowUp.svg">
                            </div>
<!--                            <div v-if="!showDetail && parseInt(lands[choosedLand].PROPERTY_365) > 0"-->
<!--                                 class="popup-price-head-discount">-->
<!--                                - {{parseInt(lands[choosedLand].PROPERTY_365)}} %-->
<!--                            </div>-->
                            <div v-if="addDiscuont && lands[choosedLand].PROPERTY_366" class="popup-price-head-price">
                                {{parseInt(parseInt(lands[choosedLand].PROPERTY_366 *
                                lands[choosedLand].PROPERTY_364*(1-lands[choosedLand].PROPERTY_365/100)) +
                                parseInt(lands[choosedLand].PROPERTY_367) + parseInt(lands[choosedLand].PROPERTY_369) +
                                parseInt(lands[choosedLand].PROPERTY_371)).toLocaleString()}} ₽
                            </div>
                            <div v-if="!addDiscuont && lands[choosedLand].PROPERTY_366" class="popup-price-head-price"
                                 :style="'color:'+((addDiscuont)? '':'#FF5C00')">
                                {{parseInt(parseInt(lands[choosedLand].PROPERTY_366 *
                                lands[choosedLand].PROPERTY_364) +
                                parseInt(lands[choosedLand].PROPERTY_367) + parseInt(lands[choosedLand].PROPERTY_369) +
                                parseInt(lands[choosedLand].PROPERTY_371)).toLocaleString()}} ₽
                            </div>
                        </div>
                    </div>
                    <div v-if="lands[choosedLand].PROPERTY_363 ==  '299'" @click="toogleCallback" class="popup-button">
                        Заказать звонок
                    </div>
                    <div v-else-if="lands[choosedLand].PROPERTY_363 ==  '301'" class="popup-button-sold">
                        <img src="/assets/images/lock.svg">Продан
                    </div>
                    <div v-else class="popup-button-blocked">
                        <img src="/assets/images/lock.svg">Занят
                    </div>
                    <div class="popup-button-more">
                        <a :href="'https://www.invest-n.ru/getfrombx24/redirect/?kadastr='+lands[choosedLand].PROPERTY_377" target="_blank">
                            Подробнее
                        </a>
                    </div>
                    <div class="images-wrapper" v-if="lands[choosedLand].PROPERTY_528">
                        <div v-if="lands[choosedLand].PROPERTY_528[0]"
                             class="image"
                             @click="slider.index = 0"
                             :style="{ backgroundImage: 'url(' + lands[choosedLand].PROPERTY_528[0] + ')' }"
                        ></div>
                        <div v-if="lands[choosedLand].PROPERTY_528[1]"
                             class="image"
                             @click="slider.index = 1"
                             :style="{ backgroundImage: 'url(' + lands[choosedLand].PROPERTY_528[1] + ')' }"
                        ></div>
                        <div v-if="lands[choosedLand].PROPERTY_528[2]"
                             class="image"
                             @click="slider.index = 2"
                             :style="{ backgroundImage: 'url(' + lands[choosedLand].PROPERTY_528[2] + ')' }"
                        ></div>
                        <div v-if="lands[choosedLand].PROPERTY_528[3]"
                             class="image"
                             @click="slider.index = 3"
                             :style="{ backgroundImage: 'url(' + lands[choosedLand].PROPERTY_528[3] + ')' }"
                        ></div>
                    </div>
                    <gallery
                            key="68463464" :images="lands[choosedLand].PROPERTY_528" :index="slider.index"
                            @close="slider.index = null"></gallery>
                </div>
            </transition>
        </div>

        <button v-if="$route.path.includes('edit')" @click="getCoordinates">Сохранить подложку</button>
        <button v-if="$route.path.includes('square')" @click="setCoordinatesSquare">Сохранить подложку</button>
        <chrome-picker v-if="$route.path.includes('square')" style="position: absolute; top:30vh;right: 10vw" v-model="colors" @input="updateColor"></chrome-picker>
    </div>


</template>

<script>

    // import VueSuggestions from 'vue-suggestions';
    // const ymaps = window.ymaps;
    // const log = window.console.log;
    // import layer from './layer.vue'
    import config from '../config';
    import {Texture} from 'vue-loading-spinner'
    import Transition from "vuikit/src/library/notification/transition";
    import FloatingLabel from 'vue-simple-floating-labels'
    import VueGallery from 'vue-gallery';
    import {Chrome}  from 'vue-color'

    export default {
        components: {
            'gallery': VueGallery,
            'chrome-picker': Chrome,
            Transition,
            Texture,
            FloatingLabel
        },
        data() {
            return {
                colors : {
                    hex: '#194d33',
                    hex8: '#194D33A8',
                    hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
                    hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
                    rgba: { r: 25, g: 77, b: 51, a: 1 },
                    a: 1
                },
                slider: {
                    index: null
                },
                choosedVill: this.$route.params.village,
                showCallback: false,
                order: {
                    name: null,
                    phone: null,
                    mail: null,
                    comment: null
                },
                site: this.$route.params.site,
                showAllVill: false,
                showDetailVill: true,
                winHeight: window.innerHeight,
                filter: {
                    show: false,
                    gas: false,
                    water: false,
                    roads: false,
                    elctr: false,
                    live: false,
                    minPrice: null,
                    maxPrice: null
                },
                currentVillage: {},
                lastChoosedVill: null,
                map: [],
                choosedLand: null,
                showDetail: false,
                addDiscuont: true,
                colorText: null,
                url: config.backend_url,
                mapReady: false,
                coordsCenter: [55.75370903771494, 37.61981338262558],
                // coordsCenter: [60.179022977567406, 30.505805864880234],
                config: config,
                village: {},
                villages: [],
                villagesMap: [],
                villagesSquareMap: [],
                villagesSquareMapEdit: {},
                lands: [],
                landsMap: [],
                centerLands: [],
                layer: null,
                showMap: false,
                loading: true,
                color: {
                    299: "#3CFF4F",
                    300: "#FFE600",
                    301: "#D22020",
                    302: "#b5b5b5",
                    304: "#D22020",
                    1080:"#00aeef"
                },
                status: {
                    299: "Свободен",
                    300: "Забронирован",
                    301: "Продан",
                    302: "Недоступен",
                    304: "Задаток",
                    1080: "Свободен"
                },
                newZoom: null,
                oldZoom: null
            }
        },
        methods: {
            newOrder (){
                let self = this;
                window.console.log(this.lands[this.choosedLand]);
                let data = {
                    village: this.$route.params.village,
                    villageName: this.currentVillage.NAME,
                    order: this.order,
                    land: (this.choosedLand)? this.lands[this.choosedLand].ID : null
                }
                this.axios.post(this.url + "Bx24/setOrder/", data).then((response) => {
                    if (response.data.result) {
                        alert("Вы успешно оставили заявку скоро наберем!");
                        self.showCallback = false;

                    } else {
                        alert("Какие-то проблемы, попробуйте еще раз отправить.");
                    }
                });
            },
            updateColor(){
                let self = this;
                this.villagesSquareMapEdit.options.set({fillColor : self.colors.hex});
            },
            toogleCallback() {
                this.showCallback = (this.showCallback) ? false : true;
            },
            closeDetailVill() {
                this.showDetailVill = false;
            },
            toogelFilter() {
                this.filter.show = (this.filter.show) ? false : true;
            },
            closeDetail() {
                this.choosedLand = false;
                this.addDiscuont = true;
            },
            goTo(e) {
                // this.showMap = false;
                // let self = this;
                // window.console.log(e);
                let to = e.srcElement.dataset.to;
                this.$router.push(to);
                this.choosedVill = to;
                this.currentVillage = this.villages.find(vill => vill.ID === this.choosedVill);
                this.printVillage();
            },
            toogleDetail() {
                this.showDetail = (this.showDetail) ? false : true;
                this.addDiscuont = true;
            },
            setCookie() {
                // this.$cookies.set("fromCoordinates", JSON.stringify(this.order.fromCoordinates), 36000000000);
                // this.$cookies.set("from", this.order.from, 36000000000);
                // this.$cookies.set("pointsCoordinates", JSON.stringify(this.order.pointsCoorinates), 36000000000);
                // this.$cookies.set("points", JSON.stringify(this.order.points), 36000000000);
                // this.$cookies.set("distanceFromMkad", this.order.distanceFromMkad, 36000000000);
            },
            setCoordinatesSquare (){
                let self = this;
                let newCoords = this.villagesSquareMapEdit.geometry.getCoordinates();
                let setCoords = [];
                newCoords[0].map(function (coord) {
                    // window.console.log(coord);
                    setCoords.push(coord[0] + ',' + coord[1]);
                });
                // window.console.log(setCoords);
                let data = {
                    id: this.$route.params.village,
                    prop: "PROPERTY_532",
                    coords: setCoords
                }
                this.axios.post(this.url + "Bx24/saveCoordsVillage/", data).then((response) => {
                    if (response.data.result) {
                        data = {
                            id: self.$route.params.village,
                            prop: "PROPERTY_534",
                            coords: self.colors.hex
                        };
                        self.axios.post(this.url + "Bx24/saveCoordsVillage/", data).then((response) => {
                            if (response.data.result) {
                                alert("Все сохранилось!");
                            }
                            else {
                                alert("Какие-то проблемы, попробуйте еще раз.");
                            }
                        });
                    } else {
                        alert("Какие-то проблемы, попробуйте еще раз.");
                    }
                });
            },
            getCoordinates() {
                let newCoords = this.village.geometry.getBounds();
                newCoords = [
                    newCoords[0][0] + "," + newCoords[0][1],
                    newCoords[0][0] + "," + newCoords[1][1],
                    newCoords[1][0] + "," + newCoords[1][1],
                    newCoords[1][0] + "," + newCoords[0][1],
                    newCoords[0][0] + "," + newCoords[0][1]
                ];
                let data = {
                    id: this.$route.params.village,
                    prop: "PROPERTY_506",
                    coords: newCoords
                }
                this.axios.post(this.url + "Bx24/saveCoordsVillage/", data).then((response) => {

                    if (response.data.result) {
                        alert("Все сохранилось!");
                    } else {
                        alert("Какие-то проблемы, попробуйте еще раз.");
                    }
                });
                // window.console.log(this.village.geometry.getBounds());
                // window.console.log(newCoords);
            },
            firstMapInit(map) {
                this.map = map;
                this.map.setType("yandex#hybrid");
            },
            mapInit(map, move = true) {
                // window.console.log("Загрузка карты");
                // this.showMap = true;
                let self = this;
                this.mapReady = true;
                this.map = map;
                let newCenter = this.villages.find(village => village.ID == self.$route.params.village).PROPERTY_510;
                let background = this.villages.find(village => village.ID == self.$route.params.village).PROPERTY_515;
                let coordVillage = this.villages.find(village => village.ID == self.$route.params.village).PROPERTY_506;
                // window.console.log(background);
                this.loading = true;
                this.village = new window.ymaps.Polygon([
                        coordVillage
                    ],
                    {
                        // balloonContent: "Тест"
                    }, {
                        fillImageHref: background,
                        zIndex: 99,
                        zIndexHover: 999,
                        hasBalloon: false,
                        draggable: false,
                        hasHint: false,
                        cursor: 'default',
                        fillOpacity: 1,
                        // Тип заливки фоном.
                        // fillMethod: 'tile',
                        // Убираем видимость обводки.
                        stroke: false
                    }
                );
                let l = 0;
                let v = 0;
                this.map.geoObjects.removeAll();
                self.villages.map(function (village) {
                    if (village.ID != self.$route.params.village) {
                        if (village.PROPERTY_532) {
                            let hintContentHover = "<div style='font-family: Arial; background-color: #ffffff;position: absolute;left:0vh;top:-1vh; display: flex;border-radius: 4vh;padding: 1vh .5vh;align-items: center;'>" +
                                "<div style='background-color: #FFC5A4; border-radius: 100%; position: absolute;left: 0;top: 0; height: 5vh; width: 5vh;display: flex;align-items: center;'>" +
                                "<img style='margin: auto; height: 5vh' src='"+village.PROPERTY_516+"'/> " +
                                "</div>" +
                                "<div style='font-size: 2.3vh;line-height: 3vh; margin-left: 7vh; margin-right: 2vh'>" +
                                village.NAME+
                                "</div>" +
                                "</div>";
                            // window.console.log(village.PROPERTY_532);
                            self.villagesSquareMap[v] = new window.ymaps.Polygon([
                                    // Указываем координаты вершин многоугольника.
                                    village.PROPERTY_532
                                ],
                                {
                                    hintContent: hintContentHover,
                                    ID: village.ID
                                }, {
                                    fillColor: (village.PROPERTY_534)? village.PROPERTY_534:"#000000",
                                    zIndex: 999,
                                    zIndexHover: 999,
                                    hasBalloon: true,
                                    hasHint: true,
                                    fillOpacity: 0.5,
                                    fillMethod: 'tile',
                                    stroke: true,
                                    strokeColor: "#000000",
                                    strokeWidth: .3
                                }
                            );
                            self.villagesSquareMap[v].events.add('click', function (e) {
                                let id = e.get('target').properties.get('ID');
                                self.loading = true;
                                self.$router.push(id);
                                self.choosedVill = id;
                                self.currentVillage = self.villages.find(vill => vill.ID === self.choosedVill);
                                self.printVillage();
                            });
                            self.villagesSquareMap[v].events.add('mousemove', function (e) {
                                let id = e.get('target').properties.get('ID');
                                self.currentVillage = self.villages.find(vill => vill.ID === id);
                            });
                            self.villagesSquareMap[v].events.add('mouseleave', function () {
                                self.currentVillage = self.villages.find(vill => vill.ID === self.$route.params.village);
                            });
                            self.map.geoObjects.add(
                                self.villagesSquareMap[v]
                            );
                        }
                        self.villagesMap[v] = new window.ymaps.Placemark(village.PROPERTY_510, {
                            balloonContent: "Сейчас все отрисуем...",
                            hintContent: village.NAME,
                            ID: village.ID
                        }, {
                            preset: 'islands#governmentCircleIcon',
                            iconColor: '#3b5998'
                        });
                        self.villagesMap[v].events.add('click', function (e) {
                            let id = e.get('target').properties.get('ID');
                            self.loading = true;
                            self.choosedLand = null;
                            self.$router.push(id);
                            self.choosedVill = id;
                            self.currentVillage = self.villages.find(vill => vill.ID === self.choosedVill);
                            self.printVillage();
                        });
                        self.villagesMap[v].events.add('mousemove', function (e) {
                            let id = e.get('target').properties.get('ID');
                            self.currentVillage = self.villages.find(vill => vill.ID === id);
                        });
                        self.villagesMap[v].events.add('mouseleave', function () {
                            self.currentVillage = self.villages.find(vill => vill.ID === self.$route.params.village);
                        });
                        // self.map.geoObjects.add(
                        //     self.villagesMap[v]
                        // );
                        v++;
                    }
                });
                if (self.$route.path.includes('square')){
                    let vill = self.villages.find(vill => vill.ID === self.$route.params.village);
                    let coords = (vill.PROPERTY_532)? vill.PROPERTY_532 : [];
                    self.colors.hex=(vill.PROPERTY_534)? vill.PROPERTY_534:"#000000"
                    self.villagesSquareMapEdit = new window.ymaps.Polygon([
                        coords
                    ], {}, {
                        editorDrawingCursor: "crosshair",
                        editorMaxPoints: 300,
                        // Цвет заливки.
                        fillColor: self.colors.hex,
                        // Цвет обводки.
                        strokeColor: '#0000FF',
                        fillOpacity: 0.5,
                        // Ширина обводки.
                        strokeWidth: 1
                    });
                    // Добавляем многоугольник на карту.
                    self.map.geoObjects.add(self.villagesSquareMapEdit);

                    // В режиме добавления новых вершин меняем цвет обводки многоугольника.
                    // var stateMonitor = new ymaps.Monitor(myPolygon.editor.state);
                    // stateMonitor.add("drawing", function (newValue) {
                    //     myPolygon.options.set("strokeColor", newValue ? '#FF0000' : '#0000FF');
                    // });

                    // Включаем режим редактирования с возможностью добавления новых вершин.
                    self.villagesSquareMapEdit.editor.startDrawing();
                }
                if (this.$route.params.village) {
                    setTimeout(() => self.lands.map(function (land) {
                        let showDiscount = 'display:none';
                        let isDiscount = false;
                        if (land.PROPERTY_365 > 0) {
                            showDiscount = '';
                            isDiscount = true;
                        }
                        let hintContentHover = "<div style='font-family: Arial; background-color: #E1E1E1;position: absolute;left:0;top:0;opacity: 0.9'>" +
                            "<div style='font-size: 3.1vh;line-height: 1.35;margin: 2.3vh 3.9vh .8vh 2.3vh'><b>" + land.PROPERTY_366 + " соток</b><img style='margin-left: 2.3vh' src='/assets/images/arrowRight.svg'></div>" +
                            "<div style='display: flex;margin: 1.3vh 3.9vh 2.3vh 2.3vh'>" +
                            "<div style='font-size: 2.3vh;color:#1C100A;line-height: 1.23; font-weight: 400; opacity: .7'>" + parseInt(land.PROPERTY_366 * land.PROPERTY_364 * (1 - land.PROPERTY_365 / 100)).toLocaleString() + " ₽</div>" +
                            "<div style='color: #FF5C00;font-weight: 700;border: solid 2px #6B8F28; border-radius: .7vh;font-size: 1.8vh;line-height: 1.42; padding: 0 0.5vh;margin-left: 1.5vh;" + showDiscount + "'>-" + parseInt(land.PROPERTY_365) + "%</div>" +
                            "</div>" +
                            "</div>";
                        self.landsMap[l] = new window.ymaps.Polygon([
                                // Указываем координаты вершин многоугольника.
                                land.PROPERTY_507
                            ],
                            // Описываем свойства геообъекта.
                            {
                                hintContent: hintContentHover,
                                ID: l
                            }, {
                                fillColor: (isDiscount && land.PROPERTY_363 == 299)? self.color[1080] :self.color[land.PROPERTY_363],
                                zIndex: 999,
                                zIndexHover: 999,
                                hasBalloon: true,
                                hasHint: true,
                                fillOpacity: 0.5,
                                // Тип заливки фоном.
                                fillMethod: 'tile',
                                stroke: true,
                                strokeColor: "#000000",
                                strokeWidth: .3
                            }
                        );
                        self.landsMap[l].events.add('mousemove', function (e) {
                            // window.console.log(e.get('target').properties.get('balloonContent'));
                            e.get('target').options.set("fillColor", '#FFFFFF');
                            e.get('target').options.set("strokeWidth",.3);
                            e.get('target').options.set("strokeColor", "#FF5C00");
                        });
                        self.landsMap[l].events.add('mouseleave', function (e) {
                            let id = e.get('target').properties.get('ID');
                            if (id != self.choosedLand) {
                                e.get('target').options.set("fillColor", (isDiscount && land.PROPERTY_363 == 299)? self.color[1080] :self.color[land.PROPERTY_363]);
                                e.get('target').options.set("strokeWidth", .1);
                                e.get('target').options.set("strokeColor", "#000000");
                            }
                        });
                        self.landsMap[l].events.add('click', function (e) {
                            // window.console.log(e);
                            // window.console.log(e.get('target').properties.get('ID'));
                            self.addDiscuont = true;
                            self.choosedLand = e.get('target').properties.get('ID');
                            e.get('target').options.set("fillColor", '#FFFFFF');
                            e.get('target').options.set("stroke", true);
                            let kk = 0;
                            while (kk <= self.landsMap.length){
                                if (kk != l) {
                                    self.landsMap[kk].options.set("fillColor", (self.lands[kk].PROPERTY_365 > 0 && self.lands[kk].PROPERTY_363 == 299) ? self.color[1080] : self.color[self.lands[kk].PROPERTY_363]);
                                    self.landsMap[kk].options.set("strokeWidth", .1);
                                    self.landsMap[kk].options.set("strokeColor", "#000000");
                                }
                                kk++;
                            }
                        });
                        self.map.geoObjects.add(self.landsMap[l]);
                        let coords = self.landsMap[l].geometry.getBounds();
                        let newX = Math.abs((coords[1][0] - coords[0][0]) / 2);
                        let newY = Math.abs((coords[1][1] - coords[0][1]) / 2);
                        let center = [
                            (coords[1][0] > coords[0][0]) ? coords[1][0] - newX : coords[1][0] + newX,
                            (coords[1][1] > coords[0][1]) ? coords[1][1] - newY : coords[0][1] + newY
                        ];
                        let zoom = self.map.getZoom();
                        let number = land.PROPERTY_437.split("-");
                        number = number[number.length - 1];
                        let landNumber = (zoom > 15) ? window.ymaps.templateLayoutFactory.createClass(
                            '<div class="numbers" style="color: #ffffff;font-size: 10px; display:block">' + number + '</div>'
                        ) : window.ymaps.templateLayoutFactory.createClass(
                            '<div class="numbers" style="color: #ffffff;font-size: 10px; display:none">' + number + '</div>'
                        );
                        self.centerLands[l] = new window.ymaps.Placemark(center, {
                            // balloonContent: "Сейчас все отрисуем...",
                            // hintContent: hintContentHover,
                            ID: l,
                            // iconContent: land.PROPERTY_437
                        }, {
                            iconLayout: 'default#imageWithContent',
                            // iconLayout: 'islands#darkGreenClusterIcons',
                            iconImageHref: '',
                            // iconColor: '#3b5998',
                            hasBalloon: false,
                            hasHint: false,
                            zIndex: -9,
                            zIndexHover: -9,
                            iconImageSize: [0, 0],
                            iconContentOffset: [-5, 0],
                            iconContentLayout: landNumber,
                        });
                        self.centerLands[l].events.add('click', function (e) {
                            self.choosedLand = e.get('target').properties.get('ID');
                        });
                        self.map.geoObjects.add(
                            self.centerLands[l]
                        );
                        l++;
                    }), 900);
                }
                this.map.geoObjects.add(this.village);
                if (this.$route.path.includes('edit')) {
                    this.village.editor.startFraming();
                }
                self.map.events.add('boundschange', function (e) {
                    let oldZoom = e.get("oldZoom");
                    let newZoom = e.get("newZoom");
                    if (self.newZoom != newZoom && self.oldZoom != oldZoom) {
                        self.newZoom = newZoom;
                        self.oldZoom = oldZoom;
                        if (oldZoom > 15 && newZoom <= 15) {
                            // window.console.log("Скрытие номера");
                            let numbers = window.document.querySelectorAll(".numbers");
                            let index = 0, length = numbers.length;
                            for (index; index < length; index++) {
                                numbers[index].style.display = "none";
                            }
                        } else if (oldZoom <= 15 && newZoom > 15) {
                            // window.console.log("Показ номера");
                            let numbers = window.document.querySelectorAll(".numbers");
                            let index = 0, length = numbers.length;
                            for (index; index < length; index++) {
                                numbers[index].style.display = "block";
                            }
                        }
                    }
                });
                this.map.geoObjects.events.add('click', function (e) {
                    if (e.get('target').properties.get('ID')) {
                        self.choosedLand = e.get('target').properties.get('ID');
                        e.get('target').options.set("fillColor", '#FFFFFF');
                        e.get('target').options.set("stroke", true);
                    }
                });
                // boundschange
                // this.map.setCenter(this.lands[10].PROPERTY_507[0]);
                // this.map.setBounds(this.landsMap.geometry.getBounds());
                if (move) {
                    let duration = 2000;
                    let delay = 400;
                    if (this.map.getCenter() == this.coordsCenter) {
                        duration = 6000;
                        delay = 800;
                        let numbers = window.document.querySelectorAll(".numbers");
                        let index = 0, length = numbers.length;
                        for (index; index < length; index++) {
                            numbers[index].style.display = "none";
                        }
                    }
                    this.map.panTo(
                        [this.map.getCenter(), newCenter],
                        {
                            delay: delay,
                            duration: duration,
                        }
                    ).then(() => {
                        setTimeout(() => {
                            self.map.setBounds(this.village.geometry.getBounds());
                            self.loading = false;
                        }, 300);

                    });
                }
            },
            setRoute() {
                let self = this;
                if (this.order.from && this.order.points[0]) {
                    if (this.order.fromCoordinates.latitude) {
                        this.order.fromCoordinates = [this.order.fromCoordinates.latitude, this.order.fromCoordinates.longitude]
                    }
                    for (let i = 0; i < this.order.points.length; i++) {
                        // window.console.log(this.order.pointsCoorinates[i]);
                        if (this.order.pointsCoorinates[i].latitude) {
                            this.order.pointsCoorinates[i] = [this.order.pointsCoorinates[i].latitude, this.order.pointsCoorinates[i].longitude];
                        }
                    }
                    this.myPointsCollection.removeAll();
                    this.map.geoObjects.remove(this.route);
                    let route = [this.order.fromCoordinates].concat(this.order.pointsCoorinates);
                    let multiRoute = new window.ymaps.multiRouter.MultiRoute({
                        // Точки маршрута. Точки могут быть заданы как координатами, так и адресом.
                        referencePoints: route,
                        params: {
                            avoidTrafficJams: true,
                        }
                    }, {
                        // Автоматически устанавливать границы карты так,
                        // чтобы маршрут был виден целиком.
                        boundsAutoApply: true,
                        routeActiveStrokeColor: "#2e3db6",
                        routeStrokeColor: "rgba(0,0,0,0)",
                        wayPointDraggable: true,
                        viaPointDraggable: true,

                    });
                    this.route = multiRoute;
                    this.map.geoObjects.add(this.route);
                    multiRoute.model.events.add('requestsuccess', function () {
                        let curRoute = self.route.getActiveRoute();
                        let length = curRoute.properties.get("distance").value;
                        self.order.time = curRoute.properties.get("durationInTraffic").value / 60;
                        self.order.time += self.timeLoad;
                        self.order.distance = Math.round(length / 1000);
                        let start = curRoute.properties.get("boundedBy")[1];
                        let end = curRoute.properties.get("boundedBy")[0];
                        let pathsObjects = curRoute.getPaths(),
                            //     //координаты линий-отрезков:
                            edges = [],
                            //     //координаты линий искомого маршрута:
                            required_edges = [];
                        // //переберём сегменты, разобьём их на отрезки-линии и заполним массив координат линий-отрезков:
                        pathsObjects.each(function (path) {
                            let coordinates = path.properties.get("coordinates");
                            for (let i = 1, l = coordinates.length; i < l; i++) {
                                edges.push([coordinates[i], coordinates[i - 1]]);
                            }
                        });
                        let nearest_points = [];
                        //nearest_points_lengths - массив длин отрезков от точки, куда кликнули, до ближайших точек на полигонах:
                        let nearest_points_lengths = [];
                        //перебираем все полигоны и заполняем массив ближайших до полигонов точек:
                        let starInMoscow = self.myGeoObjectsCollection.toArray()[0].geometry.contains(start);
                        let finishInMoscow = self.myGeoObjectsCollection.toArray()[0].geometry.contains(end);
                        self.myGeoObjectsCollection.each(function (object) {
                            if (starInMoscow && !finishInMoscow) {
                                nearest_points.push(object.geometry.getClosest(end));
                            } else {
                                nearest_points.push(object.geometry.getClosest(start));
                            }
                        });
                        //теперь заполняем массив длин отрезков от точки, куда кликнули, до ближайших точек на полигонах
                        for (let i = 0; i < nearest_points.length; i++) {
                            nearest_points_lengths.push(nearest_points[i].distance);
                        }
                        //ищем индекс того полигона, расстояние до которого минимально:
                        let ourAreaIndex = self.getMin(nearest_points_lengths).index;
                        // /*
                        //  * проверяем каждую линию-отрезок на принадлежность к нашему полигону:
                        //  */
                        let index = 0;
                        // //инветрируем массив, чтобы отрисовка начиналась с той точки, в которую кликнули:
                        // if (!starInMoscow) {
                        //     edges.reverse();
                        // }
                        // // будем работать с тем полигоном, расстояние до которого минимально: ourAreaIndex==index
                        //
                        self.myGeoObjectsCollection.each(function (object) {
                            if (ourAreaIndex == index) {
                                //переменная, сообщающая нам о том, что при переборе edges мы столкнулис с такой линией, которая лежит/частично лежит внутри полигона
                                let stop = false;
                                //перебираем все линии edges, находим те, которые лежат внутри полигона и те, которые не лежат:
                                for (let i = 0; i < edges.length; i++) {
                                    //если линии пока лежат внутри полигона:
                                    if (stop == false) {
                                        //если левая и правая точка - ВНЕ полигона - добавим эту линию в искомый массив линий (required_edges)
                                        if ((object.geometry.contains(edges[i][0]) != true) && (object.geometry.contains(edges[i][1]) != true)) {

                                            required_edges.push(edges[i]);
                                        } else {
                                            /*
                                             * опа! мы столкнулись с линией, которая пересекает наш полигон!
                                             * теперь нам нужно найти точку пересечения этой линии с полигоном!
                                             */
                                            //укажем, что дальнейший перебор не будет добавлять в required_edges данные
                                            stop = true;
                                            /*
                                             * перебираем все рёбра object-a (полигона) и проверяем, пересекает ли ребро нашу линию edges[i]
                                             */
                                            //берём внешний контур:
                                            let coordinates = object.geometry.getCoordinates()[0];
                                            for (let j = 0; j < coordinates.length - 1; j++) {
                                                let point = self.getPointOfIntersection(edges[i][0][0], edges[i][1][0], coordinates[j][0], coordinates[j + 1][0], edges[i][0][1], edges[i][1][1], coordinates[j][1], coordinates[j + 1][1]);
                                                /*
                                                 * как только нашли ребро, пересекающее нашу линию edges[i], добавим в искомый массив required_edges отрезок
                                                 * [edges[i][0], координаты точки пересечения]
                                                 */
                                                if (point) {
                                                    required_edges.push([edges[i][0], [point.x, point.y]]);
                                                }
                                            }

                                        }
                                    } else {
                                        if ((object.geometry.contains(edges[i][0]) == true) && (object.geometry.contains(edges[i][1]) == true)) {
                                            continue;
                                        } else {
                                            stop = false;
                                            let coordinates = object.geometry.getCoordinates()[0];
                                            for (let j = 0; j < coordinates.length - 1; j++) {
                                                let point = self.getPointOfIntersection(edges[i][0][0], edges[i][1][0], coordinates[j][0], coordinates[j + 1][0], edges[i][0][1], edges[i][1][1], coordinates[j][1], coordinates[j + 1][1]);
                                                /*
                                                 * как только нашли ребро, пересекающее нашу линию edges[i], добавим в искомый массив required_edges отрезок
                                                 * [edges[i][0], координаты точки пересечения]
                                                 */
                                                if (point) {
                                                    required_edges.push([edges[i][0], [point.x, point.y]]);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            index++;
                        });
                        //посчитаем суммарную длину каждого искомого отрезка (в метрах)
                        let distance = 0;
                        for (let i = 0; i < required_edges.length; i++) {
                            distance = distance + window.ymaps.coordSystem.geo.getDistance(required_edges[i][0], required_edges[i][1]);
                        }
                        self.order.distanceFromMkad = distance;
                    });
                }
            },
            printVillage() {
                let self = this;
                let vill = (this.$route.params.village) ? "vill=" + this.$route.params.village : null;
                if (vill) {
                    this.showDetailVill = true;
                }
                this.axios.get(this.url + "Bx24/getLands/?" + vill).then((response) => {
                    if (response.data) {
                        self.lands = response.data;
                        self.showMap = true;
                        self.centerLands = [];
                        // window.console.log("Отрисовка поселка");
                        self.loading = true;
                        setTimeout(() => this.mapInit(this.map), 1500);
                    } else {
                        alert("Что-то пошло не так.");
                    }
                });
            }
        },
        created() {
            // if (!this.$route.params.village) {
            //     this.$router.push("11053");
            // }
        },
        mounted() {
            let self = this;
            let vill = (this.$route.params.village) ? "vill=" + this.$route.params.village : null;
            this.axios.get(this.url + "Bx24/getVillages/").then((response) => {
                if (response.data) {
                    self.villages = response.data;
                    self.currentVillage = self.villages.find(vill => vill.ID === self.choosedVill);
                    // self.showMap = true;
                    // self.printVillage();
                    self.axios.get(self.url + "Bx24/getLands/?" + vill).then((response) => {
                        if (response.data) {
                            self.lands = response.data;
                            self.showMap = true;
                            self.centerLands = [];
                            // window.console.log("Отрисовка поселка");
                            setTimeout(() => this.mapInit(this.map), 1500);
                        } else {
                            alert("Что-то пошло не так.");
                        }
                    });
                } else {
                    alert("Что-то пошло не так.");
                }
            });
            // let self = this;
            // self.$cookies.set("fromCoordinates", '', 36000000000);
            // self.$cookies.set("from", '', 36000000000);
            // self.$cookies.set("pointsCoordinates", '', 36000000000);
            // self.$cookies.set("points", '', 36000000000);
            // this.$cookies.set("distanceFromMkad", '', 36000000000);
            // this.$cookies.set("cart", this.cart, 36000000000);
        }
    }
</script>